import React from 'react';

import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material/styles';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

import SwaggerUI from 'swagger-ui-react';

import {
    teal as get,
    lavender as put,
    skyBlue as post,
    pumpkin as del
} from '../../data/colors';

// import swaggerJson from '../../../docs/swagger.json';

const useStyles = makeStyles(theme => ({
    root: {
        '& .swagger-ui': {
            color: theme.palette.text.primary,

            // text color is specified in every effing style
            // - i don't think swagger-ui devs understand how cascading styles work
            '& .info .title': {
                color: theme.palette.primary.main,
            },
            '& .info .base-url': {
                color: theme.palette.text.primary,
            },
            '& .info p': {
                color: theme.palette.text.primary,
            },
            '& .opblock-tag': {
                color: theme.palette.text.primary,
                borderBottom: `1px solid ${alpha(theme.palette.text.primary, 0.15)}`,
            },
            '& button.expand-operation': {
                fill: theme.palette.primary.main,
            },
            '& .opblock .opblock-summary-path': {
                color: theme.palette.text.primary,
            },
            '& .opblock .opblock-summary-description': {
                color: theme.palette.primary.main,
            },
            '& .opblock-description-wrapper p': {
                color: theme.palette.text.primary,
            },
            '& .opblock-external-docs-wrapper p': {
                color: theme.palette.text.primary,
            },
            '& .opblock-title_normal p': {
                color: theme.palette.text.primary,
            },
            '& table thead tr td': {
                color: theme.palette.text.primary,
            },
            '& table thead tr th': {
                color: theme.palette.text.primary,
            },
            '& .parameter__name': {
                color: theme.palette.primary.main,
            },
            '& .parameter__type': {
                color: theme.palette.text.primary,
            },
            '& .parameter__in': {
                color: theme.palette.text.primary,
            },
            '& .tab li': {
                color: theme.palette.text.primary,
            },
            '& label': {
                color: theme.palette.text.primary,
            },
            '& table': {
                borderColor: `${alpha(theme.palette.text.primary, 0.15)}`,
            },
            '& .response-col_status': {
                color: theme.palette.primary.main,
            },
            '& .model': {
                color: theme.palette.text.primary,
            },
            '& .model-title': {
                color: theme.palette.text.primary,
            },
            '& .prop-format': {
                color: theme.palette.text.primary,
            },
            '& .prop-type': {
                color: theme.palette.primary.main,
            },
            '& table.model tr.description': {
                color: theme.palette.text.primary,
            },
            '& .model .property': {
                color: theme.palette.text.primary,
            },

            // method type colors
            // get
            '& .opblock.opblock-get': {
                borderColor: get[500],
                background: `${alpha(get[500], 0.1)}`,
            },
            '& .opblock.opblock-get .opblock-summary': {
                borderColor: get[500],
            },
            '& .opblock.opblock-get .opblock-summary-method': {
                borderColor: get[500],
                background: get[500],
            },

            // put
            '& .opblock.opblock-put': {
                borderColor: put[300],
                background: `${alpha(put[300], 0.1)}`,
            },
            '& .opblock.opblock-put .opblock-summary': {
                borderColor: put[300],
            },
            '& .opblock.opblock-put .opblock-summary-method': {
                borderColor: put[300],
                background: put[300],
            },

            // post
            '& .opblock.opblock-post': {
                borderColor: post[400],
                background: `${alpha(post[400], 0.1)}`,
            },
            '& .opblock.opblock-post .opblock-summary': {
                borderColor: post[400],
            },
            '& .opblock.opblock-post .opblock-summary-method': {
                borderColor: post[400],
                background: post[400],
            },

            // delete
            '& .opblock.opblock-delete': {
                borderColor: del[500],
                background: `${alpha(del[500], 0.1)}`,
            },
            '& .opblock.opblock-delete .opblock-summary': {
                borderColor: del[500],
            },
            '& .opblock.opblock-delet .opblock-summary-method': {
                borderColor: del[500],
                background: del[500],
            },

            // this is how you disable swagger-ui features
            '& .try-out': {
                display: 'none',
            },

            '& .scheme-container': {
                display: 'none',
            },

            '& .models': {
                display: 'none',
            },

            '& #operations-tag-all': {
                display: 'none',
            },

            '& .errors-wrapper': {
                display: 'none',
            },

            '& .wrapper': {
                marginBottom: 35,
            },

            // doc is running under below footer
            '& .info': {
                margin: '25px 0',
            },
        }
    },
}));


const Swagger = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const appName = process.env.BRICATA_APPLIANCE_TYPE === "cmc" ? "CMC" : "MC2";

    const docs = {
        CMC: "/docs/cmc-api-documentation-25.2.pdf",
        MC2: "/docs/mc2-api-documentation-25.2.pdf",
    };

    const selectedDoc = docs[appName];
    const handleLink = (link, newWindow) => {
        newWindow ? window.open(link, "_blank", "noreferrer") : navigate(link);
    };

    return (
        <main className={classes.root}>
            <div className={classes.pdf}>
                <Button onClick={() => handleLink(selectedDoc, true)}>
                    Download PDF
                </Button>
            </div>
            <SwaggerUI
                url="/docs/swagger.json"
                tryItOutEnabled={false}
                docExpansion="none"
                defaultModelExpandDepth={-1}
            />
        </main>
    );
};

export default Swagger;